import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

export const TopMenu = {
    computed: {
        ...mapState(vplSiteStore, ['menu'])
    },
    template: `
        <nav v-if="this.menu.top" class="header__nav">
            <ul>
                <li v-for="menuItem in this.menu.top.ITEMS" :key="menuItem.TEXT">
                    <a :href="menuItem.LINK">{{ menuItem.TEXT }}</a>
                </li>
            </ul>
            <button v-if="this.menu.top.EDIT_BUTTON" :onclick="this.menu.top.EDIT_BUTTON">Редактировать пункты меню</button>
        </nav>
    `
}